import apiClient from './apiClient';

export const adminAuthApi = {
  login: (email: string, password: string) =>
    apiClient.post('/auth/login', { email, password }).then((r) => r.data),
  verifyOtp: (userId: string, otp: string) =>
    apiClient.post('/auth/verify-otp', { userId, otp }).then((r) => r.data),
  logout: () => apiClient.post('/auth/logout').then((r) => r.data),
  getMe: () => apiClient.get('/auth/me').then((r) => r.data),
  updateMe: (data: Record<string, unknown>) =>
    apiClient.patch('/auth/me', data).then((r) => r.data),
};

export const adminUsersApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/users', { params }).then((r) => r.data),
  stats: () => apiClient.get('/users/stats').then((r) => r.data),
  getById: (id: string) => apiClient.get(`/users/${id}`).then((r) => r.data),
  getActivityStats: (id: string) => apiClient.get(`/users/${id}/activity-stats`).then((r) => r.data),
  getUserLikesReceived: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/likes-received`, { params }).then((r) => r.data),
  getUserLikesGiven: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/likes-given`, { params }).then((r) => r.data),
  getUserSuperLikesReceived: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/super-likes-received`, { params }).then((r) => r.data),
  getUserSuperLikesSent: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/super-likes-sent`, { params }).then((r) => r.data),
  getUserRosesReceived: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/roses-received`, { params }).then((r) => r.data),
  getUserRosesSent: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/roses-sent`, { params }).then((r) => r.data),
  getUserConversations: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/conversations`, { params }).then((r) => r.data),
  getUserLoginAttempts: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/users/${id}/activity/login-attempts`, { params }).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/users/${id}`, data).then((r) => r.data),
  updateStatus: (id: string, status: string, suspensionReason?: string) =>
    apiClient.patch(`/users/${id}/status`, { status, ...(suspensionReason ? { suspensionReason } : {}) }).then((r) => r.data),
  updateVerification: (id: string, verificationStatus: string) =>
    apiClient.patch(`/users/${id}`, { verificationStatus }).then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/users/${id}`).then((r) => r.data),
  approveDeletion: (id: string) => apiClient.post(`/users/${id}/approve-deletion`).then((r) => r.data),
};

export const adminVerificationsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/verifications', { params }).then((r) => r.data),
  approve: (id: string) => apiClient.patch(`/verifications/${id}/approve`).then((r) => r.data),
  reject: (id: string, rejectionReason: string) =>
    apiClient.patch(`/verifications/${id}/reject`, { rejectionReason }).then((r) => r.data),
};

export const adminPlansApi = {
  list: () => apiClient.get('/plans').then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/plans', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/plans/${id}`, data).then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/plans/${id}`).then((r) => r.data),
};

export const adminHottiesApi = {
  getToday: () => apiClient.get('/hotties/today').then((r) => r.data),
  setToday: (profileIds: string[]) =>
    apiClient.post('/hotties/today', { profileIds }).then((r) => r.data),
  clearToday: () => apiClient.delete('/hotties/today').then((r) => r.data),
  getEligible: (params?: Record<string, unknown>) =>
    apiClient.get('/hotties/eligible', { params }).then((r) => r.data),
};

export const adminAnalyticsApi = {
  overview: () => apiClient.get('/analytics/overview').then((r) => r.data),
  users: () => apiClient.get('/analytics/users').then((r) => r.data),
  subscriptions: () => apiClient.get('/analytics/subscriptions').then((r) => r.data),
  demographics: () => apiClient.get('/analytics/demographics').then((r) => r.data),
};

export const adminAdminsApi = {
  list: () => apiClient.get('/admins').then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/admins', data).then((r) => r.data),
  promote: (userId: string, adminRole: string) =>
    apiClient.post('/admins/promote', { userId, adminRole }).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/admins/${id}`, data).then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/admins/${id}`).then((r) => r.data),
};

export const adminSubscriptionsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/subscriptions', { params }).then((r) => r.data),
  getForUser: (userId: string) =>
    apiClient.get(`/subscriptions/${userId}`).then((r) => r.data),
  grant: (userId: string, planType: string) =>
    apiClient.post('/subscriptions/grant', { userId, planType }).then((r) => r.data),
  revoke: (userId: string) =>
    apiClient.patch(`/subscriptions/${userId}/revoke`).then((r) => r.data),
};

export const adminMessagesApi = {
  listConversations: (params?: Record<string, unknown>) =>
    apiClient.get('/messages', { params }).then((r) => r.data),
  getConversationBetween: (userA: string, userB: string) =>
    apiClient.get(`/messages/between/${userA}/${userB}`).then((r) => r.data),
  getConversation: (id: string, params?: Record<string, unknown>) =>
    apiClient.get(`/messages/${id}`, { params }).then((r) => r.data),
  deleteMessage: (conversationId: string, messageId: string) =>
    apiClient.delete(`/messages/${conversationId}/messages/${messageId}`).then((r) => r.data),
  editMessage: (conversationId: string, messageId: string, content: string, note?: string) =>
    apiClient.patch(`/messages/${conversationId}/messages/${messageId}`, { content, note }).then((r) => r.data),
  assignTier: (conversationId: string, messageId: string, tier: 0 | 1 | 2 | 3) =>
    apiClient.patch(`/messages/${conversationId}/messages/${messageId}/tier`, { tier }).then((r) => r.data),
  getModerationQueue: (params?: Record<string, unknown>) =>
    apiClient.get('/messages/moderation', { params }).then((r) => r.data),
  releaseMessage: (messageId: string) =>
    apiClient.patch(`/messages/moderation/${messageId}/release`).then((r) => r.data),
  rejectMessage: (messageId: string) =>
    apiClient.patch(`/messages/moderation/${messageId}/reject`).then((r) => r.data),
};

export const adminPaymentsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/payments', { params }).then((r) => r.data),
  getStats: () => apiClient.get('/payments/stats').then((r) => r.data),
};

export const adminSettingsApi = {
  get: () => apiClient.get('/settings').then((r) => r.data),
  update: (data: Record<string, unknown>) =>
    apiClient.patch('/settings', data).then((r) => r.data),
};

export const adminBoostTypesApi = {
  list: () => apiClient.get('/boost-types').then((r) => r.data),
  create: (data: Record<string, unknown>) => apiClient.post('/boost-types', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) => apiClient.patch(`/boost-types/${id}`, data).then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/boost-types/${id}`).then((r) => r.data),
};

export const adminRosePacksApi = {
  list: () => apiClient.get('/rose-packs').then((r) => r.data),
  create: (data: { roses: number; priceZAR: number; sortOrder?: number }) =>
    apiClient.post('/rose-packs', data).then((r) => r.data),
  update: (id: string, data: Partial<{ roses: number; priceZAR: number; active: boolean; sortOrder: number }>) =>
    apiClient.patch(`/rose-packs/${id}`, data).then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/rose-packs/${id}`).then((r) => r.data),
};

export const adminRosesApi = {
  getStats: () => apiClient.get('/roses/stats').then((r) => r.data),
  listPurchases: (params?: Record<string, unknown>) =>
    apiClient.get('/roses/purchases', { params }).then((r) => r.data),
  listTransactions: (params?: Record<string, unknown>) =>
    apiClient.get('/roses/transactions', { params }).then((r) => r.data),
  grant: (userId: string, roses: number, note?: string) =>
    apiClient.post('/roses/grant', { userId, roses, note }).then((r) => r.data),
};

export const adminNotificationsApi = {
  analytics: (params?: { from?: string; to?: string }) =>
    apiClient.get('/notifications/analytics', { params }).then((r) => r.data),
  recent: (params?: Record<string, unknown>) =>
    apiClient.get('/notifications/recent', { params }).then((r) => r.data),
};

export const adminEventsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/events', { params }).then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/events', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/events/${id}`, data).then((r) => r.data),
  delete: (id: string) =>
    apiClient.delete(`/events/${id}`).then((r) => r.data),
};

export const adminMatchesApi = {
  stats: () =>
    apiClient.get('/matches/stats').then((r) => r.data),
  listMatches: (params?: Record<string, unknown>) =>
    apiClient.get('/matches', { params }).then((r) => r.data),
  listLikes: (params?: Record<string, unknown>) =>
    apiClient.get('/matches/likes', { params }).then((r) => r.data),
  listRosesSent: (params?: Record<string, unknown>) =>
    apiClient.get('/matches/roses', { params }).then((r) => r.data),
};

export const adminSupportApi = {
  stats: () =>
    apiClient.get('/support/stats').then((r) => r.data),
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/support', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/support/${id}`).then((r) => r.data),
  reply: (id: string, message: string) =>
    apiClient.post(`/support/${id}/reply`, { message }).then((r) => r.data),
  initiate: (userId: string, category: string, message: string) =>
    apiClient.post('/support/initiate', { userId, category, message }).then((r) => r.data),
  updateStatus: (id: string, status: string) =>
    apiClient.patch(`/support/${id}/status`, { status }).then((r) => r.data),
};

export const adminReportsApi = {
  stats: () =>
    apiClient.get('/reports/stats').then((r) => r.data),
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/reports', { params }).then((r) => r.data),
  updateStatus: (id: string, status: 'reviewed' | 'dismissed') =>
    apiClient.patch(`/reports/${id}/status`, { status }).then((r) => r.data),
};

export const adminBlocksApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/blocks', { params }).then((r) => r.data),
};

export const adminStoriesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/stories', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/stories/${id}`).then((r) => r.data),
  permanentDelete: (id: string) =>
    apiClient.delete(`/stories/${id}`).then((r) => r.data),
  restore: (id: string) =>
    apiClient.patch(`/stories/${id}/restore`).then((r) => r.data),
};

export const adminSuccessStoriesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/success-stories', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/success-stories/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/success-stories', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/success-stories/${id}`, data).then((r) => r.data),
  delete: (id: string) =>
    apiClient.delete(`/success-stories/${id}`).then((r) => r.data),
};

export const adminBlogApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get('/blog', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/blog/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/blog', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.patch(`/blog/${id}`, data).then((r) => r.data),
  delete: (id: string) =>
    apiClient.delete(`/blog/${id}`).then((r) => r.data),
  uploadCoverImage: (file: File) => {
    const form = new FormData();
    form.append('image', file);
    return apiClient
      .post('/blog/upload-image', form, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((r) => r.data);
  },
};

